export default __webpack_public_path__ + "static/media/twitter-button.0139dd63.png";